export default __webpack_public_path__ + "static/media/PlusIcon.9200034b.svg";